import { render, staticRenderFns } from "./CategoryPicker.vue?vue&type=template&id=52213f2d&"
import script from "./CategoryPicker.vue?vue&type=script&lang=js&"
export * from "./CategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports